import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import {ref} from "vue";
import notificationService from "@/shared/services/NotificationService";

export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordChangeForm',
  setup(__props, { expose: __expose }) {

const _password = ref("");
const _passwordRepeat = ref("");
//const _data = ref({userName: "im a test"});
const _form = ref<InstanceType<typeof SogForm>  | null>(null)


function validate():boolean {
  if (_password.value.length === 0) {
    notificationService.error("Passwort darf nicht leer sein")
    return false
  }
  if (_password.value !== _passwordRepeat.value) {
   notificationService.error("Passwörter stimmen nicht überein")
    return false
  }
  return _form.value?.validate() ?? false;
}

function getPassword():string|undefined{
  if (_password.value === _passwordRepeat.value) {
    return _password.value;
  }
  return undefined;
}

__expose({
  getPassword,validate
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogForm, {
    ref_key: "_form",
    ref: _form
  }, {
    default: _withCtx(() => [
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _password.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_password).value = $event)),
            placeholder: "Password eingeben",
            type: "password"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _passwordRepeat.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_passwordRepeat).value = $event)),
            placeholder: "Password wiederholen",
            type: "password"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})